import md5 from 'md5'
import config from './config'

// device id
export const deviceId = () => {
  let time = Math.round(new Date().getTime() / 1000).toString()
  for (var i = 0; i < 6; i++) {
    time += Math.floor(Math.random() * 10)
  }
  return md5(time)
}

// 随机字符串
export const randomString = (len: number) => {
  let rdmString = ''
  for (; rdmString.length < len; rdmString += Math.random().toString(36).substr(2)) {}
  return rdmString.substr(0, len)
}

// 请求api生成sign验证
export const generateSign = (_params: any) => {
  var str = ''
  var sign = ''
  var keys = Object.keys(_params).sort()
  keys.forEach((key) => {
    var val = _params[key]
    str += key + val
  })
  return md5(config.appSecret + str).toUpperCase()
}

// cookie
export const cookie = {
  getCookie: (name: string, defaultValue = '') => {
    /* eslint-disable */
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return unescape(arr[2]);
    else
      return defaultValue;
    /* eslint-enable */
  },
  setCookie: (key:string, val:string) => {
    /* eslint-disable */
    var exp = new Date()
    exp.setTime(exp.getTime() + 30 * 86400 * 1000)
    document.cookie = key + '=' + val + ';expires=' + exp.toUTCString() + ';path=/'
    return document.cookie
    /* eslint-enable */
  },
  autoCookie: (key:string, val:string) => {
    /* eslint-disable */
    var exp = new Date()
    exp.setTime(exp.getTime() + 30 * 86400 * 1000)
    document.cookie = key + '=' + val + ';expires=' + exp.toUTCString() + ';path=/' + ';domain=.talkmate.com;';
    return document.cookie
    /* eslint-enable */
  },
  delCookie: (name:any) => {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = cookie.getCookie(name)
    if (cval !== null) {
      document.cookie = name + '=' + '' + ';expires=' + exp.toUTCString() + ';path=/'
      return document.cookie
    }
  },
  delCookieTalkmate: (name:string) => {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = cookie.getCookie(name)
    if (cval !== null) {
      document.cookie = name + '=' + '' + ';expires=' + exp.toUTCString() + ';path=/' + ';domain=.talkmate.com;'
      return document.cookie
    }
  }
}
